export default __webpack_public_path__ + "static/media/account.514afc27.png";